document.addEventListener( 'DOMContentLoaded', function () {
	let selectedPDF = '';
	const modal = document.getElementById( 'brochure-modal' );

	// =========================
	// OPEN MODAL ON PDF BUTTON CLICK
	// =========================
	document.addEventListener( 'click', function ( e ) {
		const button = e.target.closest( '.download-brochure .wp-block-button__link' );

		if ( button && button.href.includes( '.pdf' ) ) {
			e.preventDefault();

			selectedPDF = button.href;

			resetCF7Form();

			modal.classList.add( 'active' );
		}
	} );

	// =========================
	// CLOSE MODAL (X BUTTON)
	// =========================
	document.addEventListener( 'click', function ( e ) {
		if ( e.target.closest( '.modal-close' ) ) {
			modal.classList.remove( 'active' );

			resetCF7Form();
		}
	} );

	// =========================
	// CF7 SUCCESS EVENT
	// =========================
	document.addEventListener( 'wpcf7mailsent', function () {
		// Show success message first
		setTimeout( function () {
			if ( selectedPDF ) {
				window.open( selectedPDF, '_blank' );
			}

			modal.classList.remove( 'active' );

			resetCF7Form();
		}, 2000 ); // 2 second delay
	} );

	// =========================
	// RESET CF7 FORM FUNCTION
	// =========================
	function resetCF7Form() {
		const form = modal.querySelector( 'form' );

		if ( form ) {
			form.reset();

			form.classList.remove( 'sent' );
			form.classList.remove( 'invalid' );

			const responseOutput = form.querySelector( '.wpcf7-response-output' );

			if ( responseOutput ) {
				responseOutput.innerHTML = '';
			}
		}
	}
} );

document.addEventListener( 'DOMContentLoaded', function () {
	const openBtn = document.getElementById( 'openEnquiry' );
	const drawer = document.getElementById( 'enquiryDrawer' );
	const closeBtn = document.getElementById( 'closeDrawer' );
	const overlay = document.getElementById( 'drawerOverlay' );

	function openDrawer() {
		drawer.classList.add( 'active' );
		overlay.classList.add( 'active' );
	}

	function closeDrawer() {
		drawer.classList.remove( 'active' );
		overlay.classList.remove( 'active' );
	}

	openBtn.addEventListener( 'click', openDrawer );
	closeBtn.addEventListener( 'click', closeDrawer );
	overlay.addEventListener( 'click', closeDrawer );
} );

document.addEventListener( 'DOMContentLoaded', function () {
	const schoolSelect = document.querySelector( '[name="select-school"]' );
	const deptField = document.getElementById( 'ecole-dept-field' );

	if ( ! schoolSelect || ! deptField ) {
		return;
	}

	schoolSelect.addEventListener( 'change', function () {
		if ( this.value === 'École Centrale School of Engineering' ) {
			deptField.style.display = 'block';
		} else {
			deptField.style.display = 'none';
		}
	} );
} );

( function () {
	function init() {
		const forms = document.querySelectorAll( '.wpcf7-form' );
		forms.forEach( function ( form ) {
			const programme = form.querySelector( '[name="select-programme"]' );
			if ( ! programme ) return;
			const groups = form.querySelectorAll( '.cf-group' );

			function sync() {
				groups.forEach( function ( g ) {
					const on = g.dataset.show === programme.value;
					g.style.display = on ? '' : 'none';
					g.querySelectorAll( 'select, input, textarea' ).forEach( function ( f ) {
						f.disabled = ! on;
						if ( ! on ) f.selectedIndex = 0;
					} );
				} );
			}
			programme.addEventListener( 'change', sync );
			document.addEventListener( 'wpcf7mailsent', function ( e ) {
				if ( e.detail.contactFormId ) {
					programme.selectedIndex = 0;
					sync();
				}
			} );
			sync();
		} );
	}
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();

document.addEventListener( 'DOMContentLoaded', function () {
	const btn = document.querySelector( '.infomodal-button' );

	setTimeout( function () {
		btn.classList.add( 'show' );
	}, 3000 );
} );

document.addEventListener( 'DOMContentLoaded', function () {
	const enquiryModal = document.getElementById( 'brochure-enquiry-modal' );

	if ( ! enquiryModal ) {
		return;
	}

	document.addEventListener( 'click', function ( e ) {
		if ( e.target.closest( '.menu-item.download-brochure a' ) ) {
			e.preventDefault();
			enquiryModal.classList.add( 'active' );
			return;
		}

		if ( e.target.closest( '#brochure-enquiry-modal .modal-close' ) ) {
			enquiryModal.classList.remove( 'active' );
		}
	} );
} );
